export enum ClipboardChannels {
  WRITE_TEXT = 'WRITE_TEXT',
  READ_TEXT = 'READ_TEXT',

  WRITE_RTF = 'WRITE_RTF',
  READ_RTF = 'READ_RTF',

  WRITE_HTML = 'WRITE_HTML',
  READ_HTML = 'READ_HTML',

  WRITE_OBJECT = 'WRITE_OBJECT',
}

export interface ClipboardPayload {
  text: string | null;
  rtf: string | null;
  html: string | null;
}
